// +----------------------------------------------------------------------
// | CRMEB [ CRMEB赋能开发者，助力企业发展 ]
// +----------------------------------------------------------------------
// | Copyright (c) 2016~2021 https://www.crmeb.com All rights reserved.
// +----------------------------------------------------------------------
// | Licensed CRMEB并不是自由软件，未经许可不能去掉CRMEB相关版权
// +----------------------------------------------------------------------
// | Author: CRMEB Team <admin@crmeb.com>
// +----------------------------------------------------------------------

import Layout from '@/layout';
var contentRouter = {
  path: '/content',
  component: Layout,
  redirect: '/content/articleManager',
  name: 'content',
  meta: {
    title: '内容',
    icon: 'clipboard'
  },
  children: [{
    path: 'articleManager',
    name: 'articleManager',
    component: function component() {
      return import('@/views/content/article/list');
    },
    meta: {
      title: '文章管理',
      icon: 'clipboard'
    }
  }, {
    path: 'articleCreat/:id?',
    name: 'articleCreat',
    component: function component() {
      return import('@/views/content/article/edit');
    },
    meta: {
      title: '添加文章',
      noCache: true,
      activeMenu: "/content/articleManager"
    }
  }, {
    path: 'noteBookList',
    name: 'noteBookList',
    component: function component() {
      return import('@/views/content/noteBook/list');
    },
    meta: {
      title: '笔记管理',
      icon: 'clipboard'
    }
  }, {
    path: 'noteBook',
    name: 'noteBook',
    component: function component() {
      return import('@/views/content/noteBook/editNoteBook/index');
    },
    meta: {
      title: '发布笔记',
      icon: 'clipboard'
    }
  }, {
    path: 'classifManager',
    name: 'classifManager',
    component: function component() {
      return import('@/views/content/articleclass/list');
    },
    meta: {
      title: '文章分类',
      icon: 'clipboard'
    }
  }, {
    path: 'registrationDetail',
    name: 'registrationDetail',
    component: function component() {
      return import('@/views/content/regist/list');
    },
    meta: {
      title: '报名明细',
      icon: 'clipboard'
    }
  }, {
    path: 'service',
    name: 'service',
    component: function component() {
      return import('@/views/content/service/list');
    },
    meta: {
      title: '服务审核',
      icon: 'clipboard'
    }
  }, {
    path: 'serviceDetail/:id',
    name: 'serviceDetail',
    component: function component() {
      return import('@/views/content/service/serviceDetail');
    },
    meta: {
      title: '服务详情',
      icon: 'clipboard'
    }
  }]
};
export default contentRouter;